import Upsertable from '@/models/Upsertable'
import { useTrainingAttendanceStore } from '@/stores/trainingAttendanceStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class TrainingAttendance extends Upsertable {
  static store() {
    return useTrainingAttendanceStore()
  }

  store() {
    return TrainingAttendance.store()
  }

  static all() {
    return TrainingAttendance.store().getAll
  }

  static find(uuid) {
    const obj = TrainingAttendance.store().find(uuid)
    let training_attendance = new TrainingAttendance()
    return Object.assign(training_attendance, obj)
  }

  getAttendee() {
    const customerStore = useCustomerStore()
    const attendee = customerStore.find(this.training_attendee_uuid)
    return attendee
  }
}

useModelName(TrainingAttendance, "TrainingAttendance")
ModelRegistry.register(TrainingAttendance, "TrainingAttendance")